import React from 'react';
import { FormattedMessage } from 'react-intl';

import classes from './styles.module.css';

function RegistryChangeName({ registryFileName, onChangeRegistryName }) {
    return (
        <div className={classes.Row}>
            <h5 className={classes.Title}>
                <FormattedMessage id="RegistryChangeName.title" defaultMessage="Изменить имя" />
            </h5>

            <input
                className={classes.Input}
                type="text"
                value={registryFileName}
                onChange={(e) => onChangeRegistryName(e.target.value)}
                maxLength={45}
            />
        </div>
    );
}

export default RegistryChangeName;



// WEBPACK FOOTER //
// ./src/Components/RegistryChangeName/index.js